import React, { useEffect, useState } from 'react';
import { fetchFutureMatches } from '../util/api/requests';
import { renderSpinner } from '../util/util';
import FutureConfirmedMatchesDataTable from '../modules/datatables/FutureConfirmedMatchesDataTable';
import { Col, Row } from 'react-bootstrap';

export const FutureMatches = () => {
  const [futureMatches, setFutureMatches] = useState([]);
  const [FutureMatchesLoading, setFutureMatchesLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setFutureMatchesLoading(true);
      try {
        const matches = await fetchFutureMatches();
        if (matches) {
          setFutureMatches(matches);
        }
      } catch (error) {
        console.error('Failed to load future matches:', error);
      } finally {
        setFutureMatchesLoading(false);
      }
    })();
  }, []);

  function renderSelectAndDatatable() {
    return (
      <FutureConfirmedMatchesDataTable
        futureMatches={futureMatches}
        paging={true}
        searching={true}
        sortable={false}
      />
    );
  }

  return (
    <>
      <Row className={'justify-content-center mt-3 mb-3'}>
        <Col md={12}>
          <h3>Eelolevad mängud</h3>
        </Col>
      </Row>
      {FutureMatchesLoading ? renderSpinner() : renderSelectAndDatatable()}
    </>
  );
};
